// extracted by mini-css-extract-plugin
export default {"filter-display":"QWuqzl"};